// extracted by mini-css-extract-plugin
export default {"m":"Page404_m__8qdCS","b":"Page404_b__sWBv0"};